import React from 'react';
import { categoryLabels } from '../constants';

export function AddAccountModal({ show, accountForm, setAccountForm, availableMembers, onSubmit, onClose }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Add Dues Account</h3>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Member</label>
            <select
              value={accountForm.member_id ? `${accountForm.member_id}_${accountForm.is_proxy}` : ''}
              onChange={(e) => {
                const val = e.target.value;
                if (!val) {
                  setAccountForm({...accountForm, member_id: '', is_proxy: false});
                } else {
                  const lastUnderscoreIndex = val.lastIndexOf('_');
                  const id = val.substring(0, lastUnderscoreIndex);
                  const isProxy = val.substring(lastUnderscoreIndex + 1) === 'true';
                  setAccountForm({...accountForm, member_id: id, is_proxy: isProxy});
                }
              }}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              required
            >
              <option value="">Select a member</option>
              {availableMembers.map(m => (
                <option key={`${m.id}_${m.is_proxy}`} value={`${m.id}_${m.is_proxy}`}>
                  {m.name} {m.is_proxy ? '(Proxy)' : ''}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Category</label>
            <select
              value={accountForm.category}
              onChange={(e) => setAccountForm({...accountForm, category: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            >
              {Object.entries(categoryLabels).map(([val, label]) => (
                <option key={val} value={val}>{label}</option>
              ))}
            </select>
          </div>
          <div className="flex space-x-4">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">
              Create Account
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
